import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { LayoutProvider } from '../../contexts/LayoutContext';
import ErrorBoundary from '../common/ErrorBoundary';
import AppLayout from './AppLayout';
import LoadingSpinner from '../common/LoadingSpinner';

const AppShell = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh' 
      }}>
        <LoadingSpinner message="Loading..." />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return (
    <ErrorBoundary>
      <LayoutProvider>
        <AppLayout />
      </LayoutProvider>
    </ErrorBoundary>
  );
};

export default AppShell;